import { Injectable } from '@angular/core';
import { RequestDataAutosService } from './request-data-autos.service';
import {
  CommonDataDTO,
  TypeVehicleReturnDTO,
  CalculatorTypeVehicleParamDTO,
  CalculatorBrandParamDTO,
  CalculatorModelParamDTO,
  CalculatorVersionParamDTO,
  VersionAutoDTO,
} from '../../model/combos-model';

@Injectable()
export class RequestAutosStore {
  constructor(private combosAutos: RequestDataAutosService) {}

  public loadTypeVehicle(establishment: string): Promise<TypeVehicleReturnDTO[]> {
    return new Promise<TypeVehicleReturnDTO[]>((resolve, reject) => {
      let callTypeVehicle: CalculatorTypeVehicleParamDTO = {
        establishment: establishment,
        language: 'ES',
      };
      this.combosAutos
        .getTypeVehicle(callTypeVehicle)
        .toPromise()
        .then(
          (data) => {
            let typeVehicleList: TypeVehicleReturnDTO[] = [];
            if (data) {
              data.forEach((typeVehicle) => typeVehicleList.push(typeVehicle));
              resolve(typeVehicleList);
            } else reject(typeVehicleList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadBrand(antYear: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let callBrand: CalculatorBrandParamDTO = {
        antYear: antYear,
      };
      this.combosAutos
        .getBrand(callBrand)
        .toPromise()
        .then(
          (data) => {
            let brandList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((brand) => brandList.push(brand));
              resolve(brandList);
            } else reject(brandList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadModel(antYear: string, brand: string): Promise<CommonDataDTO[]> {
    return new Promise<CommonDataDTO[]>((resolve, reject) => {
      let callModel: CalculatorModelParamDTO = {
        antYear: antYear,
        brand: brand,
      };
      this.combosAutos
        .getModel(callModel)
        .toPromise()
        .then(
          (data) => {
            let modelList: CommonDataDTO[] = [];
            if (data) {
              data.forEach((model) => modelList.push(model));
              resolve(modelList);
            } else reject(modelList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadVersion(model: string, antYear: string, brand: string): Promise<VersionAutoDTO[]> {
    return new Promise<VersionAutoDTO[]>((resolve, reject) => {
      let callVersion: CalculatorVersionParamDTO = {
        model: model,
        brand: brand,
        year: antYear,
      };
      this.combosAutos
        .getVersion(callVersion)
        .toPromise()
        .then(
          (data) => {
            let versionList: VersionAutoDTO[] = [];
            if (data) {
              data.forEach((version) => versionList.push(version));
              resolve(versionList);
            } else reject(versionList);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }
}
